// @config
import { xervixApi } from '../config/axios.config';

// @constants
import { API_ROUTES } from '../constants/apiRoutes';

// @types
import { Statistic } from '../types/statistic.types';

const getStatistics = async (prodessionalId: string): Promise<Statistic> => {
  try {
    const response = await xervixApi.get(API_ROUTES.STATISTICS.FETCH_PROFESSIONAL_STATISTICS(prodessionalId));
    return response.data;
  } catch (error) {
    throw error
  }
};

const methodsStatistic = {
  getStatistics,
};

export default methodsStatistic;